var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopLogo'),_c('div',{staticClass:"is-flex is-justify-content-center"},[_c('img',{class:_vm.formHeaderImageClass,attrs:{"src":_vm.formHeaderImage,"alt":_vm.formHeaderImageAltText,"width":_vm.formHeaderImageWidth}})]),_c('div',{staticClass:"px-3 py-6",staticStyle:{"width":"80%","margin":"0 auto"}},[_c('div',{class:`box form-container ${
        _vm.isPageHeader
          ? `form-container-height-one`
          : `form-container-height-two`
      }`},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }